<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="550">
        <v-form v-model="formData.valid" class="mb-3" validate-on="input" @submit.prevent="submitForm">
            <v-card>
                <v-card-title id="heading" class="d-flex justify-space-between">
                    <h4 v-if="profile">Update "{{ profile.name }}" Profile</h4>
                    <h4 v-else>New Device Diagnostic Profile</h4>
                    <v-btn density="compact" icon="mdi-close" variant="flat" @click="$emit('update:modelValue',false)"/>
                </v-card-title>

                <v-container>
                    <v-alert v-if="errors.length" class="mb-3 bg-error" closable close-label="Close Alert"
                             density="compact" variant="tonal">
                        <p v-for="error in errors">{{ error }}</p>
                    </v-alert>
                    <v-row>
                        <v-col class="py-0" cols="12">
                            <v-text-field v-model="formData['name']" autofocus
                                          :rules="[vRules.required,vRules.maxLength(32)]"
                                          density="compact" label="Name"/>
                        </v-col>
                    </v-row>
                </v-container>

                <v-card-actions class="mt-2 px-4 d-flex justify-end">
                    <v-btn profile="button" size="small"
                           @click="$emit('update:modelValue',false)">
                        Close
                    </v-btn>
                    <v-btn :disabled="!formData.valid" color="primary" size="small" type="submit">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script setup>
import {ref, reactive, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    profile: Object,
});
const formData = reactive({
    valid: false,
    name: props.profile?.name ?? null,
});
const emits = defineEmits(['update:modelValue', 'addProfile', 'updateProfile']);
const dialogSwitch = ref(props.modelValue);
const content = ref("{\n\n}");
const errors = ref([]);

onMounted(() => {
    if (props.profile?.format) {
        const validJson = validateJSON(props.profile.format)
        if (validJson) {
            content.value = JSON.stringify(validJson, null, 4);
        }
    }
})

const validateJSON = (json) => {
    try {
        return JSON.parse(json);
    } catch (error) {
        return false;
    }
};

const submitForm = () => {
    errors.value = [];
    if (!formData['name']) {
        errors.value.push(`Name is required`);
        return false;
    }

    send(`${props.profile ? 'put' : 'post'}`,
        `admin/diagnostics/profiles${props.profile ? '/' + props.profile.id : ''}`,
        formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message);
            if (response.data.success) {
                emits(props.profile ? 'updateProfile' : 'addProfile', response.data.data);
                emits('update:modelValue', false);
            }
        })
        .catch(function (errorResponse) {
            if (errorResponse.response?.data?.errors) {
                let validationErrors = errorResponse.response.data.errors;
                Object.keys(validationErrors).forEach((key) => {
                    errors.value.push(validationErrors[key][0]);
                });
            } else if (errorResponse.response?.data.message) {
                errors.value.push(errorResponse.response.data.message);
            }
            snackbar.showSnackbar('Something went wrong', 'error');
            document.getElementById('heading').scrollIntoView({behavior: 'smooth'});
        })
}

</script>
